const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:5001/api",
};

export default config;